import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#44403c",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.4",
      d: "M18 10a8 8 0 0 1-8 8m8-8a8 8 0 0 0-8-8m8 8H2m8 8a8 8 0 0 1-8-8m8 8a11.6 11.6 0 0 1 0-16m0 16a11.6 11.6 0 0 0 0-16m-8 8a8 8 0 0 1 8-8"
    }, null, -1)
  ]))]))
}
export default { render: render }